module.exports = __webpack_public_path__ + "media/bootstrap-icons/suit-heart-fill-c475f559.svg";